<template>
  <div>
    <app-loading v-bind:loading="loading"></app-loading>
    <app-enquire
      v-if="packageDetail"
      :showEnquiry="showEnquire"
      :product="packageDetail"
      v-on:closeEnquiry="showEnquire = false"
    ></app-enquire>
    <div class="package-detail-grid" id="package-detail" v-if="packageDetail">
      <div class="header-bar">
        <div class="container header-container">
          <a
            class="button app-secondary"
            v-if="packageDetail.spechome"
            @click="goBack"
          >
            Go Back
          </a>

          <a
            class="button app-primary"
            v-if="favoriteHnl.includes(packageDetail.cpidstring)"
          >
            <i class="fas fa-heart"></i>
            THIS IS SAVED IN YOUR FAVORITES
          </a>

          <a class="button app-accent" v-on:click="toggleShare()">
            <i class="fas fa-link"></i>
            <div class="share-box" v-bind:class="{ 'is-visible': showShare }">
              <!--            <i class="fab fa-facebook-f" v-on:click="shareFb()"></i>-->
              <i class="fas fa-link" v-on:click="copyLink()"></i>
              <i class="fas fa-envelope" v-on:click="shareEmail()"></i>
              <input id="paste-box" type="text" value="" />
            </div>
            <div class="px-3" id="linkcp">Link Copied!</div>
            SHARE
          </a>

          <a
            class="button app-accent"
            @click="packagePdfPrintEvent()"
            :href="packageDetail.builderpdfurl"
            target="_blank"
            v-if="loaded"
          >
            <i class="fas fa-file-pdf"></i>
            Print
          </a>

          <a class="button app-enquiry" @click="showEnquire = true">
            <i class="fas fa-envelope"></i>
            Let us help you!
          </a>
        </div>
      </div>

      <div class="container">
        <div class="columns is-multiline is-variable is-6 boxes">
          <div class="column is-6-desktop is-12-tablet is-12-mobile grid-box">
            <div
              class="facade-header"
              v-if="packageDetail.estimatedcompletiondate"
            >
              <p class="available-date">
                Available
                {{
                  new Date(packageDetail.estimatedcompletiondate).toDateString()
                }}
              </p>
            </div>
            <div class="facade-box box">
              <img :src="packageDetail.imagepath" alt="Placeholder image" />
              <div class="columns package-detail is-gapless">
                <div class="column">
                  <p class="product">
                    {{ packageDetail.designproductname }}
                    {{ packageDetail.facadeproductname }}
                  </p>
                  <p class="builder-name">
                    {{ packageDetail.buildername }}
                  </p>
                </div>
                <div class="column is-narrow has-text-right">
                  <div></div>
                  <div class="amenities ml-0">
                    <div class="amenity">
                      <img :src="require('@/assets/icons/bed.svg')" alt="" />
                      <span>{{ packageDetail.noofbedrooms }}</span>
                    </div>
                    <div class="amenity">
                      <img :src="require('@/assets/icons/bath.svg')" alt="" />
                      <span>{{ packageDetail.noofbathrooms }}</span>
                    </div>
                    <div class="amenity">
                      <img :src="require('@/assets/icons/car.svg')" alt="" />
                      <span>{{ packageDetail.noofcarparks }}</span>
                    </div>
                  </div>
                  <p class="price">
                    <span class="from">From</span>
                    {{
                       formatCurrency(packageDetail.productprice)
                    }}
                  </p>
                </div>
              </div>
            </div>

            <div class="box">
              <div class="box-header">
                <p class="s-title">
                  Details
                </p>
              </div>
              <div class="box-body">
                <div class="lot-fit-dimensions">
                  <div class="columns is-multiline">
                    <div class="column is-6">
                      <p class="dim-title">Square Footage</p>
                      <p class="dim">
                        {{ packageDetail.homesize.toLocaleString() }}
                        <small>sqft</small>
                      </p>
                    </div>
                    <div class="column is-6">
                      <p class="dim-title">Home Width</p>
                      <p class="dim">
                        {{ packageDetail.homeWidthFormatted.replace("'", "") }}
                        <small>ft</small>
                      </p>
                    </div>
                    <div class="column is-6">
                      <p class="dim-title">Lot Area</p>
                      <p class="dim">
                        {{ packageDetail.lotsize.toLocaleString() }}
                        <small>sqft</small>
                      </p>
                    </div>
                    <div class="column is-6">
                      <p class="dim-title">Lot Width</p>
                      <p class="dim">
                        {{ packageDetail.lotWidthFormatted.replace("'", "") }}
                        <small>ft</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box location-box" v-if="packageDetail">
              <div class="box-header">
                <p class="s-title">
                  Location
                </p>
              </div>
              <div class="box-body">
                <p class="address">
                  {{ packageDetail.productaddress }}
                </p>
                <app-location-map
                  v-bind:lotId="packageDetail.lotproductcpid"
                ></app-location-map>
              </div>
            </div>
          </div>

          <div class="column is-6-desktop is-12-tablet is-12-mobile grid-box">
            <div class="box">
              <div class="floorplan-section">
                <a
                  :href="packageDetail.floorplanimageurl"
                  data-lightbox="floorplan"
                  data-title="Floorplan"
                >
                  <img :src="packageDetail.floorplanimageurl" />
                </a>
              </div>
            </div>

            <div
              class="box"
              v-if="
                packageDetail.siteplansvgurl &&
                  packageDetail.buildername !== 'Highland Homes'
              "
            >
              <div class="box-header">
                <p class="s-title">
                  Lot Fit
                </p>
              </div>
              <div class="box-body floorplan-section">
                <a
                  v-bind:href="packageDetail.siteplansvgurl"
                  data-lightbox="floorplan"
                  data-title="Siting"
                >
                  <img v-bind:src="packageDetail.siteplansvgurl" />
                </a>
              </div>
            </div>

            <div class="box gallery-section" v-if="galleries.length > 0">
              <p class="s-title">
                Gallery
              </p>
              <div class="columns is-mobile is-multiline is-variable is-2">
                <div class="column is-6" v-for="gallery in galleries">
                  <a
                    :href="gallery.url"
                    data-lightbox="interior"
                    data-title="Interior"
                  >
                    <img :src="gallery.url" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationMap from "@/components/journey/package/LocationMap";
import Loading from "@/components/journey/Loading";
import favoriteStore from "@/store/favorite";
import Enquiry from "@/components/journey/Enquiry";

export default {
  name: "app-community-homes",
  mixins: [],
  components: {
    "app-loading": Loading,
    "app-location-map": LocationMap,
    "app-enquire": Enquiry
  },
  data() {
    return {
      packageId: null,
      packageDetail: null,
      galleries: [],
      showShare: false,
      sub: null,
      count: 0,
      loading: true,
      loaded: false,
      favoriteHnl: [],
      showEnquire: false
    };
  },
  watch: {
    "$route.params": {
      handler(n, o) {
        if (n !== o) {
          this.packageDetail = null;
          this.packageId = this.$route.params.id;
          this.getPackageDetail();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.favoriteHnl = this.$store.getters.favoriteHnl;
  },
  destroyed() {
    this.sub();
  },
  methods: {
    formatCurrency: function(value) {
      if (value) {
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      } else {
        return "$0";
      }
    },
    getPackageDetail: function() {
      this.favoriteHnl = this.$store.getters.favoriteHnlIds;
      this.$store.dispatch("getPackageDetail", this.packageId);
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === "setPackageDetail") {
          this.packageDetail = state.communityStore.packageDetail;
          this.$store.dispatch("productTracking", {
            page: "hnl-package",
            product: this.packageDetail
          });
          this.loading = false;
          if (this.packageDetail.buildername !== "Highland Homes") {
            return this.checkSiting();
          }
          this.loaded = true;
        }

        if (mutation.type === "setFavoriteHnl") {
          this.favoriteHnl = state.favoriteStore.favoriteHnl;
        }
      });
    },

    addToFavorite: function() {
      this.$store.dispatch("setFavoriteHnl", this.packageDetail.cpidstring);
    },

    openPackageEnquiry: function() {},

    packagePdfPrintEvent: function() {},

    toggleShare: function() {
      this.showShare = !this.showShare;
    },

    isFavorite: function() {},

    zoomIn: function() {},

    zoomOut: function() {},

    shareFb: function() {},

    checkSiting: function() {
      if (this.count < 5) {
        setTimeout(() => {
          if (this.packageDetail.siteplansvgurl === null) {
            this.count += 1;
            this.$store.dispatch("getPackageDetail", this.packageId);
          } else {
            this.loaded = true;
          }
        }, 5000);
      }
    },

    copyLink: function() {
      const url = window.location.href;
      const el = document.getElementById("paste-box");
      el.value = url;
      el.select();
      document.execCommand("copy");
      const flashel = document.getElementById("linkcp");
      flashel.classList.add("is-visible");
      setTimeout(function() {
        flashel.classList.remove("is-visible");
      }, 2000);
    },

    shareEmail: function() {
      const url = window.location.href;
      const subject = "Check out this home";
      const body = `Check out this home: ${url}`;
      window.location.href = `mailto:?subject=${subject}&body=${body}`;
    },

    goBack: function() {
      let url = "/community/move-in/";
      const origin = this.$route.params.origin;
      if (origin) {
        url = url + origin;
      }
      return this.$router.push({
        path: url
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/journey/package/Package.vue